import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import '../css/Map.css';
import { ContentContainer, MainContent, CenteredCard, StyledTableContainer, StyledTableHead, StyledTableColumn, StyledTableCell, RefreshIcon, CustomTextField, HeaderTitle } from '../Styles/VS_Analytics';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLogoTitle } from '../classes/LogoTitleContext';
import Header from '../Parts/Header';
import Footer from '../Parts/Footer';
import Sidebar from '../Parts/Sidebar';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid';
import CardContent from '@mui/material/CardContent';
import { format } from 'date-fns';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { Radio, RadioGroup, FormControlLabel, Switch } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import refreshIcon from '../Images/refresh-icon.svg';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormGroup from '@mui/material/FormGroup';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import axios from 'axios';
import getAuthHeaders from '../Auth/Authentication';
import { API_ENDPOINTS } from '../Auth/apiConfig';
import pdfIcon from '../Images/pdf-icon.svg';
import excelIcon from '../Images/excel-icon.svg';
import dayjs from 'dayjs';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { utils, writeFile } from 'xlsx';
import autoTable from 'jspdf-autotable';
import moment from 'moment';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

const VSAnalytics = ({ onLogout, userData, loggedInUser }) => {
    const theme = useTheme();
    const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState();
    const [username, setUsername] = useState();
    const [userRole, setUserRole] = useState('');
    const { logoUrl, projectTitle } = useLogoTitle();
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [selectedDPs, setSelectedDPs] = useState([]);
    const [selectedVPs, setSelectedVPs] = useState([]);
    const levelOptions = [
        { value: 'VacuumLevel', label: 'Avg vacuum level (bar)' },
        { value: 'MaxTankLevel', label: 'Max tank level (m)' },
        { value: 'MinTankLevel', label: 'Min tank level (m)' },
        { value: 'TotalAlarm', label: 'Total alarm' },
        { value: 'TotalAlarmPerDay', label: 'Total alarm/day' },
    ];
    const [selectedLevels, setSelectedLevels] = useState([]);
    const levelTwoOptions = [
        { value: 'VacuumLevelTwo', label: 'Avg vacuum level (2) (bar)' },
        { value: 'MaxTankLevelTwo', label: 'Max tank level (2) (m)' },
        { value: 'MinTankLevelTwo', label: 'Min tank level (2) (m)' },
    ];
    const [selectedLevelsTwo, setSelectedLevelsTwo] = useState([]);
    const parameterOptions = [
        { value: 'TotalDuration', label: 'Total run time' },
        { value: 'AverageDuration', label: 'Avg run time' },
        { value: 'MaxDuration', label: 'Max run time' },
        { value: 'MinDuration', label: 'Min run time' },
        { value: 'TotalCycles', label: 'Total runs' },
        { value: 'TotalCyclesPerDay', label: 'Total runs per day' },
    ];
    const [selectedParameters, setSelectedParameters] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedDateFrom, setSelectedDateFrom] = useState(null);
    const [selectedDateTo, setSelectedDateTo] = useState(null);
    const [dpOptions, setDpOptions] = useState([]);
    const [vpOptions, setVpOptions] = useState([]);
    const [minValue, setMinValue] = useState(null);
    const [maxValue, setMaxValue] = useState(null);
    const [tableData1, setTableData1] = useState([]);
    const [tableData1DefaultReport, settableData1DefaultReport] = useState([]);
    const [detailedData, setDetailedData] = useState([]);
    const [detailedDataDP1DP2, setDetailedDataDP1DP2] = useState([]);
    const [detailedDataVP, setDetailedDataVP] = useState([]);
    const [minmaxData, setminmaxData] = useState([]);
    const [minmaxDataTwo, setminmaxDataTwo] = useState([]);
    const [minmaxDataDefaultReport, setminmaxDataDefaultReport] = useState([]);
    const [minmaxDataDefaultReportTwo, setminmaxDataDefaultReportTwo] = useState([]);
    const [totalperdaydata, settotalperdaydata] = useState([]);
    const [totalperdaydataDefaultReport, settotalperdaydataDefaultReport] = useState([]);
    const detailedData3Ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [totalPumpCyclesData, setTotalPumpCyclesData] = useState({
        dp1: [],
        dp2: [],
        dp3: [],
        dp4: [],
        vp1: [],
        vp2: [],
        vp3: [],
        vp4: [],
        vp5: [],
        vp6: [],
        vp7: [],
        vp8: [],
        vp9: [],
        alarmData: [],
    });

    const notify = (message) => toast.info(message, {
        css: {
            fontSize: '16px',
            '@media (max-width: 600px)': {
                fontSize: '14px',
            },
        },
    });

    const today = new Date(); // today's date
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(today.getDate() - 40);

    const [currentPageOne, setCurrentPageOne] = useState(1);
    const [currentPageTwo, setCurrentPageTwo] = useState(1);
    const [currentPageThree, setCurrentPageThree] = useState(1);

    const rowsPerPageOne = 15;
    const rowsPerPageTwo = 15;
    const rowsPerPageThree = 15;

    // Calculate the index range for the current page
    const startRowIndexOne = (currentPageOne - 1) * rowsPerPageOne;
    const endRowIndexOne = startRowIndexOne + rowsPerPageOne;

    // Calculate the index range for the current page
    const startRowIndexTwo = (currentPageTwo - 1) * rowsPerPageTwo;
    const endRowIndexTwo = startRowIndexTwo + rowsPerPageTwo;

    // Calculate the index range for the current page
    const startRowIndexThree = (currentPageThree - 1) * rowsPerPageThree;
    const endRowIndexThree = startRowIndexThree + rowsPerPageThree;

    // Paginate the data
    const paginatedDataOne = detailedData.slice(startRowIndexOne, endRowIndexOne);
    const paginatedDataTwo = detailedDataDP1DP2.slice(startRowIndexTwo, endRowIndexTwo);
    const paginatedDataThree = detailedDataVP.slice(startRowIndexThree, endRowIndexThree);

    // Handle page change event
    const handlePageChangeOne = (event, newPage) => {
        setCurrentPageOne(newPage);
    };

    // Handle page change event
    const handlePageChangeTwo = (event, newPage) => {
        setCurrentPageTwo(newPage);
    };

    // Handle page change event
    const handlePageChangeThree = (event, newPage) => {
        setCurrentPageThree(newPage);
    };

    const handleDefaultGenerate = async () => {
        setLoading(true);
        handleClear();
        // Get current date and date 7 days ago
        const currentDate = moment().format('YYYY-MM-DD');
        const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');

        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.get(API_ENDPOINTS.vshandlesearchone, {
                params: {
                    selectedDPs: dpOptions.map(dp => dp.pumpname),
                    selectedVPs: vpOptions.map(vp => vp.pumpname),
                    selectedDateFrom: sevenDaysAgo,
                    selectedDateTo: currentDate,
                    clientId: loggedInUser.clientId,
                    Customerid: loggedInUser.customerID
                },
                headers: authHeaders
            });

            // Log the response data
            //console.log('Response Data of vs analytics:', response.data);

            // Assuming response.data is the array of objects returned from the API
            const responseData = response.data;
            settableData1DefaultReport(responseData);

            // Fetch minmax data and set state
            await fetchminmaxDefaultReport();

            await fetchminmaxDefaultReportTwo();

            await fetchTotalPumpCyclesDataDefaultReport();

            await fetchDetailedPumpCyclesVP();

            await fetchDetailedPumpCyclesDefaultReport();

            setLoading(false);
        } catch (error) {
            console.error('Error fetching table data:', error);
            setLoading(false);
        }
    };

    const fetchminmaxDefaultReport = async () => {
        try {
            const currentDate = moment().format('YYYY-MM-DD');
            const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.minmoaxvsanatcs}`, {
                Dyx: loggedInUser.Dyx,
                M: loggedInUser.M,
                clientId: loggedInUser.clientId,
                selectedDateFrom: sevenDaysAgo,
                selectedDateTo: currentDate,
            },
                { headers: authHeaders });

            setminmaxDataDefaultReport(response.data);
            //console.log('MIN MAX cycles:', response.data);
        } catch (error) {
            console.error('Error fetching MIN MAX cycles:', error);
            // Ensure minmaxData state is set appropriately on error
            setminmaxDataDefaultReport([]);
        }
    };

    const fetchminmaxDefaultReportTwo = async () => {
        try {
            const currentDate = moment().format('YYYY-MM-DD');
            const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.minmoaxvsanatcsTwo}`, {
                Dyx: loggedInUser.Dyx,
                M: loggedInUser.M,
                clientId: loggedInUser.clientId,
                selectedDateFrom: sevenDaysAgo,
                selectedDateTo: currentDate,
            },
                { headers: authHeaders });

            setminmaxDataDefaultReportTwo(response.data);
            //console.log('MIN MAX cycles:', response.data);
        } catch (error) {
            console.error('Error fetching MIN MAX cycles:', error);
            // Ensure minmaxData state is set appropriately on error
            setminmaxDataDefaultReportTwo([]);
        }
    };

    const fetchTotalPumpCyclesDataDefaultReport = async () => {
        try {
            setLoading(true);
            const currentDate = moment().format('YYYY-MM-DD');
            const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.TotalPumpCyclesData}`, {
                TimeDiff: loggedInUser.TimeDiff,
                clientId: loggedInUser.clientId,
                projectID: loggedInUser.Projectid,
                selectedDateFrom: sevenDaysAgo,
                selectedDateTo: currentDate,
            }, { headers: authHeaders });

            // Check if the response is successful and contains data
            if (response.data.success) {
                const data = response.data.results;
                // Process the data as needed
                //('Processed Data:', data);

                // Update state with the processed data
                settotalperdaydataDefaultReport(data);

            } else {
                console.error('API response indicates failure:', response.data);
            }
        } catch (error) {
            console.error('Error fetching total pump cycles data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = async () => {
        if (selectedDateFrom && selectedDateTo) {
            setLoading(true);
            handleClearDefaultGenerate();
            try {
                const authHeaders = getAuthHeaders();
                const response = await axios.get(API_ENDPOINTS.vshandlesearchone, {
                    params: {
                        selectedDPs,
                        selectedVPs,
                        selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                        selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
                        clientId: loggedInUser.clientId,
                        Customerid: loggedInUser.customerID
                    },
                    headers: authHeaders
                });

                // Log the response data
                //console.log('Response Data of vs analytics:', response.data);

                // Assuming response.data is the array of objects returned from the API
                const responseData = response.data;
                setTableData1(responseData);

                // Fetch minmax data and set state
                await fetchminmax();

                await fetchminmaxTwo();

                await fetchTotalPumpCyclesData();


                setLoading(false);
            } catch (error) {
                console.error('Error fetching table data:', error);
                setLoading(false);
            }
        } else {
            alert('Add the From_date and To_date for perform search');
        }
    };

    const fetchminmax = async () => {
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.minmoaxvsanatcs}`, {
                Dyx: loggedInUser.Dyx,
                M: loggedInUser.M,
                clientId: loggedInUser.clientId,
                selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
            },
                { headers: authHeaders });

            setminmaxData(response.data);
            //console.log('MIN MAX cycles:', response.data);
        } catch (error) {
            console.error('Error fetching MIN MAX cycles:', error);
            // Ensure minmaxData state is set appropriately on error
            setminmaxData([]);
        }
    };

    const fetchminmaxTwo = async () => {
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.minmoaxvsanatcsTwo}`, {
                Dyx: loggedInUser.Dyx,
                M: loggedInUser.M,
                clientId: loggedInUser.clientId,
                selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
            },
                { headers: authHeaders });

            setminmaxDataTwo(response.data);
            //console.log('MIN MAX cycles:', response.data);
        } catch (error) {
            console.error('Error fetching MIN MAX cycles:', error);
            // Ensure minmaxData state is set appropriately on error
            setminmaxDataTwo([]);
        }
    };

    const fetchTotalPumpCyclesData = async () => {
        try {
            setLoading(true);
            handleClearDefaultGenerate();
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.TotalPumpCyclesData}`, {
                TimeDiff: loggedInUser.TimeDiff,
                clientId: loggedInUser.clientId,
                projectID: loggedInUser.Projectid,
                selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
            }, { headers: authHeaders });

            // Check if the response is successful and contains data
            if (response.data.success) {
                const data = response.data.results;
                // Process the data as needed
                //console.log('Processed Data:', data);

                // Update state with the processed data
                settotalperdaydata(data);

            } else {
                console.error('API response indicates failure:', response.data);
            }
        } catch (error) {
            console.error('Error fetching total pump cycles data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleClear = () => {
        settableData1DefaultReport([]);
        setSelectedDateFrom(null);
        setSelectedDateTo(null);
        setTableData1([]);
        settotalperdaydataDefaultReport([]);
        settotalperdaydata([]);
        setminmaxData([]);
        setminmaxDataTwo([]);
        setminmaxDataDefaultReport([]);
        setminmaxDataDefaultReportTwo([]);
        setDetailedData([]);
        setDetailedDataDP1DP2([]);
        setDetailedDataVP([]);
    };

    const handleClearDefaultGenerate = () => {
        settableData1DefaultReport([]);
        settotalperdaydataDefaultReport([]);
        setminmaxDataDefaultReport([]);
        setminmaxDataDefaultReportTwo([]);
        setDetailedData([]);
        setDetailedDataDP1DP2([]);
        setDetailedDataVP([]);
    }

    const renderTableColumns = () => {
        const columnsToRender = [
            { key: 'PUMPNAME', label: 'Pump Name' },
        ];

        if (selectedParameters.includes('TotalDuration')) {
            columnsToRender.push({ key: 'TOTALDURATION', label: 'Total run time' });
        }
        if (selectedParameters.includes('AverageDuration')) {
            columnsToRender.push({ key: 'AVGDURATION', label: 'Avg run time' });
        }
        if (selectedParameters.includes('MaxDuration')) {
            columnsToRender.push({ key: 'MAXDURATION', label: 'Max run time' });
        }
        if (selectedParameters.includes('MinDuration')) {
            columnsToRender.push({ key: 'MINDURATION', label: 'Min run time' });
        }
        if (selectedParameters.includes('TotalCycles')) {
            columnsToRender.push({ key: 'CountDuration', label: 'Total runs' });
        }

        return columnsToRender;
    };

    const renderTableColumnsDefaultreport = () => {
        const columnsToRenderDefaultReport = [
            { key: 'PUMPNAME', label: 'Pump Name' },
        ];
        columnsToRenderDefaultReport.push({ key: 'TOTALDURATION', label: 'Total run time' });
        columnsToRenderDefaultReport.push({ key: 'AVGDURATION', label: 'Avg run time' });
        columnsToRenderDefaultReport.push({ key: 'MAXDURATION', label: 'Max run time' });
        columnsToRenderDefaultReport.push({ key: 'MINDURATION', label: 'Min run time' });
        columnsToRenderDefaultReport.push({ key: 'CountDuration', label: 'Total runs' });
        return columnsToRenderDefaultReport;
    };

    const fetchDetailedPumpCyclesDefaultReport = async () => {
        try {
            const currentDate = moment().format('YYYY-MM-DD');
            const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
            const authHeaders = getAuthHeaders();

            const response = await axios.post(`${API_ENDPOINTS.DetailedPumpCyclesDefaultReport}`, {
                PUMPNAMEDP1: 'DP1',
                PUMPNAMEDP2: 'DP2',
                PUMPNAMEDP3: 'DP3',
                PUMPNAMEDP4: 'DP4',
                //PUMPNAMEVP1: 'VP1',  
                //PUMPNAMEVP2: 'VP2',  
                //PUMPNAMEVP3: 'VP3',  
                //PUMPNAMEVP4: 'VP4',  
                TimeDiff: loggedInUser.TimeDiff,
                clientId: loggedInUser.clientId,
                projectID: loggedInUser.Projectid,
                selectedDateFrom: sevenDaysAgo,
                selectedDateTo: currentDate,
            }, { headers: authHeaders });

            setDetailedDataDP1DP2(response.data);
            //console.log('Detailed pump cycles:', response.data);
        } catch (error) {
            console.error('Error fetching detailed pump cycles:', error);
        }
    };

    const fetchDetailedPumpCyclesVP = async () => {
        try {
            const currentDate = moment().format('YYYY-MM-DD');
            const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');
            const authHeaders = getAuthHeaders();

            const response = await axios.post(`${API_ENDPOINTS.DetailedReportVP}`, {
                PUMPNAMEVP1: 'VP1',
                PUMPNAMEVP2: 'VP2',
                PUMPNAMEVP3: 'VP3',
                PUMPNAMEVP4: 'VP4',
                PUMPNAMEVP5: 'VP5',
                PUMPNAMEVP6: 'VP6',
                PUMPNAMEVP7: 'VP7',
                PUMPNAMEVP8: 'VP8',
                PUMPNAMEVP9: 'VP9',
                TimeDiff: loggedInUser.TimeDiff,
                clientId: loggedInUser.clientId,
                projectID: loggedInUser.Projectid,
                selectedDateFrom: sevenDaysAgo,
                selectedDateTo: currentDate,
            }, { headers: authHeaders });

            setDetailedDataVP(response.data);
            //console.log('Detailed pump cycles:', response.data);
        } catch (error) {
            console.error('Error fetching detailed pump cycles:', error);
        }
    };

    const fetchDetailedPumpCycles = async (pumpName) => {
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.post(`${API_ENDPOINTS.DetailedPumpCycles}`, {
                PUMPNAME: pumpName,
                TimeDiff: loggedInUser.TimeDiff,
                clientId: loggedInUser.clientId,
                projectID: loggedInUser.Projectid,
                selectedDateFrom: selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : null,
                selectedDateTo: selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : null,
            }, { headers: authHeaders });

            setDetailedData(response.data);

            if (detailedData3Ref.current && detailedData.length > 0) {
                //console.log('detailedData3Ref is set:', detailedData3Ref.current);
                //console.log('Scrolling to detailedData3 table');
                detailedData3Ref.current.scrollIntoView();
            } else {
                //console.log('detailedData3Ref is not set or detailedData is empty');
            }

            //console.log('Detailed pump cycles:', response.data);
        } catch (error) {
            console.error('Error fetching detailed pump cycles:', error);
        }
    };

    const formatDate = (dateString) => {
        // Parse the date string in the format DD-MM-YYYY HH:MM:SS
        const [datePart] = dateString.split(' '); // Extract the date part
        const [day, month, year] = datePart.split('-'); // Split into day, month, year
        return `${day}/${month}/${year}`; // Format as DD/MM/YYYY
    };

    const formatTime = (dateString) => {
        if (!dateString) {
            return ''; // Return an empty string if the dateString is falsy
        }

        // Split the dateString into date and time parts
        const parts = dateString.split(' ');

        // Check if the time part exists
        if (parts.length < 2) {
            return ''; // Return an empty string if there's no time part
        }

        const timePart = parts[1]; // Get the time part

        // If the time part exists, return it formatted as HH:MM:SS
        return timePart.split(':').slice(0, 3).join(':');
    };

    const handlePumpNameClick = (pumpName) => {
        fetchDetailedPumpCycles(pumpName);
    };

    const handleDownloadPDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
        });

        // Function to generate table content
        const generateTableContent = (tableData, columns, startY) => {
            const rows = tableData.map(row => {
                return columns.map(column => {
                    // Handle different types of data based on the column key
                    switch (column.key) {
                        case 'PUMPNAME':
                            return row.PUMPNAME || '0';
                        case 'TOTALDURATION':
                            return row.TOTALDURATION || '0Sec';
                        case 'AVGDURATION':
                            return row.AVGDURATION || '0Sec';
                        case 'MAXDURATION':
                            return row.MAXDURATION || '0Sec';
                        case 'MINDURATION':
                            return row.MINDURATION || '0Sec';
                        case 'CountDuration':
                            return row.CountDuration || '0'
                        case 'Date':
                            return row.Date;
                        case 'dp1totalduration':
                            return row.dp1totalduration || '0Sec';
                        case 'dp1totalcycles':
                            return row.dp1totalcycles || '0';
                        case 'dp2totalduration':
                            return row.dp2totalduration || '0Sec';
                        case 'dp2totalcycles':
                            return row.dp2totalcycles || '0';
                        case 'dp3totalduration':
                            return row.dp3totalduration || '0Sec';
                        case 'dp3totalcycles':
                            return row.dp3totalcycles || '0';
                        case 'dp4totalduration':
                            return row.dp4totalduration || '0Sec';
                        case 'dp4totalcycles':
                            return row.dp4totalcycles || '0';
                        case 'vp1totalduration':
                            return row.vp1totalduration || '0Sec';
                        case 'vp1totalcycles':
                            return row.vp1totalcycles || '0';
                        case 'vp2totalduration':
                            return row.vp2totalduration || '0Sec';
                        case 'vp2totalcycles':
                            return row.vp2totalcycles || '0';
                        case 'vp3totalduration':
                            return row.vp3totalduration || '0Sec';
                        case 'vp3totalcycles':
                            return row.vp3totalcycles || '0';
                        case 'vp4totalduration':
                            return row.vp4totalduration || '0Sec';
                        case 'vp4totalcycles':
                            return row.vp4totalcycles || '0';
                        case 'vp5totalduration':
                            return row.vp4totalduration || '0Sec';
                        case 'vp5totalcycles':
                            return row.vp4totalcycles || '0';
                        case 'vp6totalduration':
                            return row.vp6totalduration || '0Sec';
                        case 'vp6totalcycles':
                            return row.vp6totalcycles || '0';
                        case 'vp7totalduration':
                            return row.vp7totalduration || '0Sec';
                        case 'vp7totalcycles':
                            return row.vp7totalcycles || '0';
                        case 'vp8totalduration':
                            return row.vp8totalduration || '0Sec';
                        case 'vp8totalcycles':
                            return row.vp8totalcycles || '0';
                        case 'vp9totalduration':
                            return row.vp9totalduration || '0Sec';
                        case 'vp9totalcycles':
                            return row.vp9totalcycles || '0';
                        case 'Alarm':
                            return row.Alarm || '0';
                        case 'averageVac':
                            return row.averageVac.length > 0 ? row.averageVac[0].VACUUM : '0';
                        case 'maxTank':
                            return row.maxTank.length > 0 ? row.maxTank[0].MAXTANK : '0';
                        case 'minTank':
                            return row.minTank.length > 0 ? row.minTank[0].MINTANK : '0';
                        case 'averageVac2':
                            return row.averageVac2.length > 0 ? row.averageVac2[0].VACUUM : '0';
                        case 'maxTank2':
                            return row.maxTank2.length > 0 ? row.maxTank2[0].MAXTANK : '0';
                        case 'minTank2':
                            return row.minTank2.length > 0 ? row.minTank2[0].MINTANK : '0';
                        case 'totalAlarm':
                            return row.totalAlarm.length > 0 ? row.totalAlarm[0].Alarm : '0';
                        case 'pumpname':
                            return row.pumpname || '-';
                        case 'STARTDATE':
                            return formatDate(row.starttime) || 'NA';
                        case 'STARTTIME':
                            return formatTime(row.starttime) || 'NA';
                        case 'STOPDATE':
                            return formatDate(row.time) || 'NA';
                        case 'STOPTIME':
                            return formatTime(row.time) || 'NA';
                        case 'DURATION':
                            return row.DURATION || '0Sec';
                        default:
                            return '';
                    }
                });
            });

            // Add a smaller space after each table
            doc.autoTable({
                head: [columns.map(column => column.label)],
                body: rows,
                startY: startY,
                headStyles: {
                    fillColor: [200, 200, 200],
                    // Grey color (RGB: 169, 169, 169)
                    textColor: [0, 0, 0],
                    fontSize: 12,
                    fontStyle: 'bold',
                },
                theme: 'striped',
            });

            return doc.autoTable.previous.finalY + 10;
        };

        // Add Title
        const title = 'VS Analytics Report';
        const titleWidth = doc.getStringUnitWidth(title) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const pageWidth = doc.internal.pageSize.width;
        const xTitle = (pageWidth - titleWidth) / 2;
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(18);
        doc.text(title, xTitle, 20);

        // Add Project Name below the title
        const projectName = `Project Name: ${loggedInUser && loggedInUser.project_description}`;
        const projectNameWidth = doc.getStringUnitWidth(projectName) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const xProjectName = (pageWidth - projectNameWidth) / 2;
        doc.text(projectName, xProjectName, 30);

        // Add From Date below the Project Name
        const currentDate = moment().format('DD-MM-YYYY');
        const sevenDaysAgo = moment().subtract(7, 'days').format('DD-MM-YYYY');
        const fromDateText = `Date between: ${selectedDateFrom ? format(selectedDateFrom, 'dd-MM-yyyy') : sevenDaysAgo} / ${selectedDateTo ? format(selectedDateTo, 'dd-MM-yyyy') : currentDate}`;
        const fromDateWidth = doc.getStringUnitWidth(fromDateText) * doc.internal.getFontSize() / doc.internal.scaleFactor;
        const xFromDate = (pageWidth - fromDateWidth) / 2;
        doc.text(fromDateText, xFromDate, 40);

        // Starting y-position for the first table
        let startY = 50;

        // Generate PDF content based on each table
        if (tableData1.length > 0) {
            const columns1 = renderTableColumns().map(column => column);
            startY = generateTableContent(tableData1, columns1, startY);
        }

        // Generate PDF content based on each table
        if (tableData1DefaultReport.length > 0) {
            const columns1 = renderTableColumnsDefaultreport().map(column => column);
            startY = generateTableContent(tableData1DefaultReport, columns1, startY);
        }

        if (minmaxData && Object.keys(minmaxData).length > 0) {
            const columns2 = [
                ...(selectedLevels.includes('VacuumLevel') ? [
                    { key: 'averageVac', label: 'Average Vacuum Level (bar)' },
                ] : []),
                ...(selectedLevels.includes('MaxTankLevel') ? [
                    { key: 'maxTank', label: 'Max Tank Level (m)' },
                ] : []),
                ...(selectedLevels.includes('MinTankLevel') ? [
                    { key: 'minTank', label: 'Min Tank Level (m)' },
                ] : []),
                ...(selectedLevels.includes('TotalAlarm') ? [
                    { key: 'totalAlarm', label: 'Total Alarm' }
                ] : []),
            ];
            startY = generateTableContent([minmaxData], columns2, startY);
        }

        if (loggedInUser && loggedInUser.VacuumLevel2CardEnabled) {
            if (minmaxData && Object.keys(minmaxData).length > 0) {
                const columns2 = [
                    ...(selectedLevels.includes('VacuumLevelTwo') ? [
                        { key: 'averageVac', label: 'Avg vacuum level (2) (bar)' },
                    ] : []),
                    ...(selectedLevels.includes('MaxTankLevelTwo') ? [
                        { key: 'maxTank', label: 'Max tank level (2) (m)' },
                    ] : []),
                    ...(selectedLevels.includes('MinTankLevelTwo') ? [
                        { key: 'minTank', label: 'Min tank level (2) (m)' },
                    ] : []),
                ];
                startY = generateTableContent([minmaxData], columns2, startY);
            }
        }

        if (minmaxDataDefaultReport && Object.keys(minmaxDataDefaultReport).length > 0) {
            const columns2 = [
                { key: 'averageVac', label: 'Average Vacuum Level (bar)' },
                { key: 'maxTank', label: 'Max Tank Level (m)' },
                { key: 'minTank', label: 'Min Tank Level (m)' },
                { key: 'totalAlarm', label: 'Total Alarm' }
            ];
            startY = generateTableContent([minmaxDataDefaultReport], columns2, startY);
        }

        if (loggedInUser && loggedInUser.VacuumLevel2CardEnabled) {
            if (minmaxDataDefaultReportTwo && Object.keys(minmaxDataDefaultReportTwo).length > 0) {
                const columns2 = [
                    { key: 'averageVac2', label: 'Avg vacuum level (2) (bar)' },
                    { key: 'maxTank2', label: 'Max tank level (2) (m)' },
                    { key: 'minTank2', label: 'Min tank level (2) (m)' },
                ];
                startY = generateTableContent([minmaxDataDefaultReportTwo], columns2, startY);
            }
        }

        if (totalperdaydata.length > 0) {
            // Define columns dynamically based on selectedDPs, selectedVPs, and selectedLevels
            const columns3 = [
                ...(selectedParameters.includes('TotalCyclesPerDay') || selectedLevels.includes('TotalAlarmPerDay') ? [
                    { key: 'Date', label: 'Date' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP1') ? [
                    { key: 'dp1totalduration', label: 'DP1 total run time' },
                    { key: 'dp1totalcycles', label: 'DP1 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP2') ? [
                    { key: 'dp2totalduration', label: 'DP2 total run time' },
                    { key: 'dp2totalcycles', label: 'DP2 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP3') ? [
                    { key: 'dp3totalduration', label: 'DP3 total run time' },
                    { key: 'dp3totalcycles', label: 'DP3 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP4') ? [
                    { key: 'dp4totalduration', label: 'DP4 total run time' },
                    { key: 'dp4totalcycles', label: 'DP4 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP1') ? [
                    { key: 'vp1totalduration', label: 'VP1 total run time' },
                    { key: 'vp1totalcycles', label: 'VP1 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP2') ? [
                    { key: 'vp2totalduration', label: 'VP2 total run time' },
                    { key: 'vp2totalcycles', label: 'VP2 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP3') ? [
                    { key: 'vp3totalduration', label: 'VP3 total run time' },
                    { key: 'vp3totalcycles', label: 'VP3 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP4') ? [
                    { key: 'vp4totalduration', label: 'VP4 total run time' },
                    { key: 'vp4totalcycles', label: 'VP4 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP5') ? [
                    { key: 'vp5totalduration', label: 'VP5 total run time' },
                    { key: 'vp5totalcycles', label: 'VP5 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP6') ? [
                    { key: 'vp6totalduration', label: 'VP6 total run time' },
                    { key: 'vp6totalcycles', label: 'VP6 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP7') ? [
                    { key: 'vp7totalduration', label: 'VP7 total run time' },
                    { key: 'vp7totalcycles', label: 'VP7 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP8') ? [
                    { key: 'vp8totalduration', label: 'VP8 total run time' },
                    { key: 'vp8totalcycles', label: 'VP8 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP9') ? [
                    { key: 'vp9totalduration', label: 'VP9 total run time' },
                    { key: 'vp9totalcycles', label: 'VP9 total runs' }
                ] : []),
                ...(selectedLevels.includes('TotalAlarmPerDay') ? [
                    { key: 'Alarm', label: 'Total alarm/day' }
                ] : [])
            ];
            startY = generateTableContent(totalperdaydata, columns3, startY);
        }

        if (totalperdaydataDefaultReport.length > 0) {
            // Define columns dynamically based on selectedDPs, selectedVPs, and selectedLevels
            const columns3 = [
                { key: 'Date', label: 'Date' },
                ...(dpOptions.some(dp => dp.pumpname === 'DP1') ? [
                    { key: 'dp1totalduration', label: 'DP1 total run time' },
                    { key: 'dp1totalcycles', label: 'DP1 total runs' }
                ] : []),
                ...(dpOptions.some(dp => dp.pumpname === 'DP2') ? [
                    { key: 'dp2totalduration', label: 'DP2 total run time' },
                    { key: 'dp2totalcycles', label: 'DP2 total runs' }
                ] : []),
                ...(dpOptions.some(dp => dp.pumpname === 'DP3') ? [
                    { key: 'dp3totalduration', label: 'DP3 total run time' },
                    { key: 'dp3totalcycles', label: 'DP3 total runs' }
                ] : []),
                ...(dpOptions.some(dp => dp.pumpname === 'DP4') ? [
                    { key: 'dp4totalduration', label: 'DP4 total run time' },
                    { key: 'dp4totalcycles', label: 'DP4 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP1') ? [
                    { key: 'vp1totalduration', label: 'VP1 total run time' },
                    { key: 'vp1totalcycles', label: 'VP1 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP2') ? [
                    { key: 'vp2totalduration', label: 'VP2 total run time' },
                    { key: 'vp2totalcycles', label: 'VP2 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP3') ? [
                    { key: 'vp3totalduration', label: 'VP3 total run time' },
                    { key: 'vp3totalcycles', label: 'VP3 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP4') ? [
                    { key: 'vp4totalduration', label: 'VP4 total run time' },
                    { key: 'vp4totalcycles', label: 'VP4 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP5') ? [
                    { key: 'vp5totalduration', label: 'VP5 total run time' },
                    { key: 'vp5totalcycles', label: 'VP5 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP6') ? [
                    { key: 'vp6totalduration', label: 'VP6 total run time' },
                    { key: 'vp6totalcycles', label: 'VP6 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP7') ? [
                    { key: 'vp7totalduration', label: 'VP7 total run time' },
                    { key: 'vp7totalcycles', label: 'VP7 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP8') ? [
                    { key: 'vp8totalduration', label: 'VP8 total run time' },
                    { key: 'vp8totalcycles', label: 'VP8 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP9') ? [
                    { key: 'vp9totalduration', label: 'VP9 total run time' },
                    { key: 'vp9totalcycles', label: 'VP9 total runs' }
                ] : []),
                { key: 'Alarm', label: 'Total alarm/day' }
            ];

            startY = generateTableContent(totalperdaydataDefaultReport, columns3, startY);
        }

        if (detailedData.length > 0) {
            const columns4 = [
                { key: 'pumpname', label: 'Pump name' },
                { key: 'STARTDATE', label: 'Start date' },
                { key: 'STARTTIME', label: 'Start time' },
                { key: 'STOPDATE', label: 'Stop date' },
                { key: 'STOPTIME', label: 'Stop time' },
                { key: 'DURATION', label: 'Run time' }
            ];

            startY = generateTableContent(detailedData, columns4, startY);
        }

        if (detailedDataDP1DP2.length > 0) {
            const columns5 = [
                { key: 'pumpname', label: 'Pump name' },
                { key: 'STARTDATE', label: 'Start date' },
                { key: 'STARTTIME', label: 'Start time' },
                { key: 'STOPDATE', label: 'Stop date' },
                { key: 'STOPTIME', label: 'Stop time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            startY = generateTableContent(detailedDataDP1DP2, columns5, startY);
        }

        if (detailedDataVP.length > 0) {
            const columns6 = [
                { key: 'pumpname', label: 'Pump name' },
                { key: 'STARTDATE', label: 'Start date' },
                { key: 'STARTTIME', label: 'Start time' },
                { key: 'STOPDATE', label: 'Stop date' },
                { key: 'STOPTIME', label: 'Stop time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            startY = generateTableContent(detailedDataVP, columns6, startY);
        }
        // Save the PDF
        doc.save('vs_analytics_report.pdf');
    };

    const handleDownloadExcel = () => {
        const XLSX = require('xlsx');
        const wb = XLSX.utils.book_new();
        const wsData = [];
        const currentDate = moment().format('DD-MM-YYYY');
        const sevenDaysAgo = moment().subtract(7, 'days').format('DD-MM-YYYY');

        // Header lines
        const headerLines = [
            ['VS Analytics Report'],
            [`Project Name: ${loggedInUser && loggedInUser.project_description}`],
            [`Date between: ${selectedDateFrom ? format(selectedDateFrom, 'yyyy-MM-dd') : sevenDaysAgo} / ${selectedDateTo ? format(selectedDateTo, 'yyyy-MM-dd') : currentDate}`]
        ];
        wsData.push(...headerLines);

        // Function to generate Excel content for a specific data set
        const generateExcelContent = (data, columns) => {
            const header = columns.map(column => column.label);
            const rows = data.map(row => columns.map(column => {
                switch (column.key) {
                    case 'PUMPNAME':
                        return row.PUMPNAME || '-';
                    case 'TOTALDURATION':
                        return row.TOTALDURATION || '0Sec';
                    case 'AVGDURATION':
                        return row.AVGDURATION || '0Sec';
                    case 'MAXDURATION':
                        return row.MAXDURATION || '0Sec';
                    case 'MINDURATION':
                        return row.MINDURATION || '0Sec';
                    case 'CountDuration':
                        return row.CountDuration || '0';
                    case 'Date':
                        return row.Date || '';
                    case 'dp1totalduration':
                        return row.dp1totalduration || '0Sec';
                    case 'dp1totalcycles':
                        return row.dp1totalcycles || '0';
                    case 'dp2totalduration':
                        return row.dp2totalduration || '0Sec';
                    case 'dp2totalcycles':
                        return row.dp2totalcycles || '0';
                    case 'dp3totalduration':
                        return row.dp3totalduration || '0Sec';
                    case 'dp3totalcycles':
                        return row.dp3totalcycles || '0';
                    case 'dp4totalduration':
                        return row.dp4totalduration || '0Sec';
                    case 'dp4totalcycles':
                        return row.dp4totalcycles || '0';
                    case 'vp1totalduration':
                        return row.vp1totalduration || '0Sec';
                    case 'vp1totalcycles':
                        return row.vp1totalcycles || '0';
                    case 'vp2totalduration':
                        return row.vp2totalduration || '0Sec';
                    case 'vp2totalcycles':
                        return row.vp2totalcycles || '0';
                    case 'vp3totalduration':
                        return row.vp3totalduration || '0Sec';
                    case 'vp3totalcycles':
                        return row.vp3totalcycles || '0';
                    case 'vp4totalduration':
                        return row.vp4totalduration || '0Sec';
                    case 'vp4totalcycles':
                        return row.vp4totalcycles || '0';
                    case 'vp5totalduration':
                        return row.vp5totalduration || '0Sec';
                    case 'vp5totalcycles':
                        return row.vp5totalcycles || '0';
                    case 'vp6totalduration':
                        return row.vp6totalduration || '0Sec';
                    case 'vp6totalcycles':
                        return row.vp6totalcycles || '0';
                    case 'vp7totalduration':
                        return row.vp7totalduration || '0Sec';
                    case 'vp7totalcycles':
                        return row.vp7totalcycles || '0';
                    case 'vp8totalduration':
                        return row.vp8totalduration || '0Sec';
                    case 'vp8totalcycles':
                        return row.vp8totalcycles || '0';
                    case 'vp9totalduration':
                        return row.vp9totalduration || '0Sec';
                    case 'vp9totalcycles':
                        return row.vp9totalcycles || '0';
                    case 'Alarm':
                        return row.Alarm || '0';
                    case 'averageVac':
                        return row.averageVac.length > 0 ? row.averageVac[0].VACUUM : '';
                    case 'maxTank':
                        return row.maxTank.length > 0 ? row.maxTank[0].MAXTANK : '';
                    case 'minTank':
                        return row.minTank.length > 0 ? row.minTank[0].MINTANK : '';
                    case 'totalAlarm':
                        return row.totalAlarm.length > 0 ? row.totalAlarm[0].Alarm : '';
                    case 'averageVac2':
                        return row.averageVac2.length > 0 ? row.averageVac2[0].VACUUM : '0';
                    case 'maxTank2':
                        return row.maxTank2.length > 0 ? row.maxTank2[0].MAXTANK : '0';
                    case 'minTank2':
                        return row.minTank2.length > 0 ? row.minTank2[0].MINTANK : '0';
                    case 'pumpname':
                        return row.pumpname || '-';
                    case 'STARTDATE':
                        return formatDate(row.starttime) || 'NA';
                    case 'STARTTIME':
                        return formatTime(row.starttime) || 'NA';
                    case 'STOPDATE':
                        return formatDate(row.time) || 'NA';
                    case 'STOPTIME':
                        return formatTime(row.time) || 'NA';
                    case 'DURATION':
                        return row.DURATION || '0Sec';
                    default:
                        return '';
                }
            }));

            // Add empty row for spacing
            rows.push(Array(header.length).fill(''));

            return [header, ...rows];
        };

        // Append Table1 data
        if (tableData1.length > 0) {
            const columns1 = renderTableColumns().map(column => column);
            wsData.push(...generateExcelContent(tableData1, columns1));
        }

        // Append Table1 data
        if (tableData1DefaultReport.length > 0) {
            const columns1 = renderTableColumnsDefaultreport().map(column => column);
            wsData.push(...generateExcelContent(tableData1DefaultReport, columns1));
        }

        // Append MinMaxData
        if (minmaxData && Object.keys(minmaxData).length > 0) {
            const columns2 = [
                ...(selectedLevels.includes('VacuumLevel') ? [
                    { key: 'averageVac', label: 'Average Vacuum Level (bar)' },
                ] : []),
                ...(selectedLevels.includes('MaxTankLevel') ? [
                    { key: 'maxTank', label: 'Max Tank Level (m)' },
                ] : []),
                ...(selectedLevels.includes('MinTankLevel') ? [
                    { key: 'minTank', label: 'Min Tank Level (m)' },
                ] : []),
                ...(selectedLevels.includes('TotalAlarm') ? [
                    { key: 'totalAlarm', label: 'Total Alarm' }
                ] : []),
            ];
            wsData.push(...generateExcelContent([minmaxData], columns2));
        }

        if (loggedInUser && loggedInUser.VacuumLevel2CardEnabled) {
            if (minmaxData && Object.keys(minmaxData).length > 0) {
                const columns2 = [
                    ...(selectedLevels.includes('VacuumLevelTwo') ? [
                        { key: 'averageVac', label: 'Avg vacuum level (2) (bar)' },
                    ] : []),
                    ...(selectedLevels.includes('MaxTankLevelTwo') ? [
                        { key: 'maxTank', label: 'Max tank level (2) (m)' },
                    ] : []),
                    ...(selectedLevels.includes('MinTankLevelTwo') ? [
                        { key: 'minTank', label: 'Min tank level (2) (m)' },
                    ] : []),
                ];
                wsData.push(...generateExcelContent([minmaxData], columns2));
            }
        }

        // Append MinMaxData
        if (minmaxDataDefaultReport && Object.keys(minmaxDataDefaultReport).length > 0) {
            const columns2 = [
                { key: 'averageVac', label: 'Average Vacuum Level (bar)' },
                { key: 'maxTank', label: 'Max Tank Level (m)' },
                { key: 'minTank', label: 'Min Tank Level (m)' },
                { key: 'totalAlarm', label: 'Total Alarm' }
            ];
            wsData.push(...generateExcelContent([minmaxDataDefaultReport], columns2));
        }

        if (loggedInUser && loggedInUser.VacuumLevel2CardEnabled) {
            if (minmaxDataDefaultReportTwo && Object.keys(minmaxDataDefaultReportTwo).length > 0) {
                const columns2 = [
                    { key: 'averageVac2', label: 'Avg vacuum level (2) (bar)' },
                    { key: 'maxTank2', label: 'Max tank level (2) (m)' },
                    { key: 'minTank2', label: 'Min tank level (2) (m)' },
                ];
                wsData.push(...generateExcelContent([minmaxDataDefaultReportTwo], columns2));
            }
        }

        // Append TotalPerDayData
        if (totalperdaydata.length > 0) {
            const columns3 = [
                ...(selectedParameters.includes('TotalCyclesPerDay') || selectedLevels.includes('TotalAlarmPerDay') ? [
                    { key: 'Date', label: 'Date' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP1') ? [
                    { key: 'dp1totalduration', label: 'DP1 total run time' },
                    { key: 'dp1totalcycles', label: 'DP1 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP2') ? [
                    { key: 'dp2totalduration', label: 'DP2 total run time' },
                    { key: 'dp2totalcycles', label: 'DP2 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP3') ? [
                    { key: 'dp3totalduration', label: 'DP3 total run time' },
                    { key: 'dp3totalcycles', label: 'DP3 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP4') ? [
                    { key: 'dp4totalduration', label: 'DP4 total run time' },
                    { key: 'dp4totalcycles', label: 'DP4 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP1') ? [
                    { key: 'vp1totalduration', label: 'VP1 total run time' },
                    { key: 'vp1totalcycles', label: 'VP1 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP2') ? [
                    { key: 'vp2totalduration', label: 'VP2 total run time' },
                    { key: 'vp2totalcycles', label: 'VP2 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP3') ? [
                    { key: 'vp3totalduration', label: 'VP3 total run time' },
                    { key: 'vp3totalcycles', label: 'VP3 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP4') ? [
                    { key: 'vp4totalduration', label: 'VP4 total run time' },
                    { key: 'vp4totalcycles', label: 'VP4 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP5') ? [
                    { key: 'vp5totalduration', label: 'VP5 total run time' },
                    { key: 'vp5totalcycles', label: 'VP5 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP6') ? [
                    { key: 'vp6totalduration', label: 'VP6 total run time' },
                    { key: 'vp6totalcycles', label: 'VP6 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP7') ? [
                    { key: 'vp7totalduration', label: 'VP7 total run time' },
                    { key: 'vp7totalcycles', label: 'VP7 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP8') ? [
                    { key: 'vp8totalduration', label: 'VP8 total run time' },
                    { key: 'vp8totalcycles', label: 'VP8 total runs' }
                ] : []),
                ...(selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP9') ? [
                    { key: 'vp9totalduration', label: 'VP9 total run time' },
                    { key: 'vp9totalcycles', label: 'VP9 total runs' }
                ] : []),
                ...(selectedLevels.includes('TotalAlarmPerDay') ? [
                    { key: 'Alarm', label: 'Total alarm/day' }
                ] : [])
            ];
            wsData.push(...generateExcelContent(totalperdaydata, columns3));
        }

        // Append TotalPerDayData
        if (totalperdaydataDefaultReport.length > 0) {
            const columns3 = [
                { key: 'Date', label: 'Date' },
                ...(dpOptions.some(dp => dp.pumpname === 'DP1') ? [
                    { key: 'dp1totalduration', label: 'DP1 total run time' },
                    { key: 'dp1totalcycles', label: 'DP1 total runs' }
                ] : []),
                ...(dpOptions.some(dp => dp.pumpname === 'DP2') ? [
                    { key: 'dp2totalduration', label: 'DP2 total run time' },
                    { key: 'dp2totalcycles', label: 'DP2 total runs' }
                ] : []),
                ...(dpOptions.some(dp => dp.pumpname === 'DP3') ? [
                    { key: 'dp3totalduration', label: 'DP3 total run time' },
                    { key: 'dp3totalcycles', label: 'DP3 total runs' }
                ] : []),
                ...(dpOptions.some(dp => dp.pumpname === 'DP4') ? [
                    { key: 'dp4totalduration', label: 'DP4 total run time' },
                    { key: 'dp4totalcycles', label: 'DP4 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP1') ? [
                    { key: 'vp1totalduration', label: 'VP1 total run time' },
                    { key: 'vp1totalcycles', label: 'VP1 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP2') ? [
                    { key: 'vp2totalduration', label: 'VP2 total run time' },
                    { key: 'vp2totalcycles', label: 'VP2 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP3') ? [
                    { key: 'vp3totalduration', label: 'VP3 total run time' },
                    { key: 'vp3totalcycles', label: 'VP3 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP4') ? [
                    { key: 'vp4totalduration', label: 'VP4 total run time' },
                    { key: 'vp4totalcycles', label: 'VP4 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP5') ? [
                    { key: 'vp5totalduration', label: 'VP5 total run time' },
                    { key: 'vp5totalcycles', label: 'VP5 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP6') ? [
                    { key: 'vp6totalduration', label: 'VP6 total run time' },
                    { key: 'vp6totalcycles', label: 'VP6 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP7') ? [
                    { key: 'vp7totalduration', label: 'VP7 total run time' },
                    { key: 'vp7totalcycles', label: 'VP7 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP8') ? [
                    { key: 'vp8totalduration', label: 'VP8 total run time' },
                    { key: 'vp8totalcycles', label: 'VP8 total runs' }
                ] : []),
                ...(vpOptions.some(vp => vp.pumpname === 'VP9') ? [
                    { key: 'vp9totalduration', label: 'VP9 total run time' },
                    { key: 'vp9totalcycles', label: 'VP9 total runs' }
                ] : []),
                { key: 'Alarm', label: 'Total alarm/day' }
            ];
            wsData.push(...generateExcelContent(totalperdaydataDefaultReport, columns3));
        }

        if (detailedData.length > 0) {
            const columns4 = [
                { key: 'pumpname', label: 'Pump Name' },
                { key: 'STARTDATE', label: 'Start Date' },
                { key: 'STARTTIME', label: 'Start Tme' },
                { key: 'STOPDATE', label: 'Stop Date' },
                { key: 'STOPTIME', label: 'Stop Time' },
                { key: 'DURATION', label: 'Run time' }
            ];

            wsData.push(...generateExcelContent(detailedData, columns4));
        }

        if (detailedDataDP1DP2.length > 0) {
            const columns5 = [
                { key: 'pumpname', label: 'Pump Name' },
                { key: 'STARTDATE', label: 'Start Date' },
                { key: 'STARTTIME', label: 'Start Tme' },
                { key: 'STOPDATE', label: 'Stop Date' },
                { key: 'STOPTIME', label: 'Stop Time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            wsData.push(...generateExcelContent(detailedDataDP1DP2, columns5));
        }

        if (detailedDataVP.length > 0) {
            const columns6 = [
                { key: 'pumpname', label: 'Pump Name' },
                { key: 'STARTDATE', label: 'Start Date' },
                { key: 'STARTTIME', label: 'Start Tme' },
                { key: 'STOPDATE', label: 'Stop Date' },
                { key: 'STOPTIME', label: 'Stop Time' },
                { key: 'DURATION', label: 'Run time' }
            ];
            wsData.push(...generateExcelContent(detailedDataVP, columns6));
        }

        // Create a single worksheet from all data
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Set column widths and style for centered alignment
        const range = XLSX.utils.decode_range(ws['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
            const colWidth = wsData.reduce((acc, row) => Math.max(acc, `${row[C]}`.length), 0) + 3;
            ws['!cols'] = ws['!cols'] || [];
            ws['!cols'][C] = { wch: colWidth, s: { alignment: { horizontal: 'center' } } };
        }

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, 'VSAna');

        // Save the Excel file
        XLSX.writeFile(wb, 'vs_analytics_report.xlsx');
    };

    const handleDateFrom = (date) => {
        setSelectedDateFrom(date);
    };

    const handleDateTo = (date) => {
        setSelectedDateTo(date);
    };

    // Fetch the DP options when the component mounts
    const fetchDpVPOptions = async () => {
        try {
            const authHeaders = getAuthHeaders();
            const response = await axios.get(`${API_ENDPOINTS.DpVPOptions}?Customerid=${loggedInUser?.customerID}`, {
                headers: authHeaders
            });

            //console.log('DP and VP Options:', response.data);

            const dpPumps = response.data.filter(pump => pump.pumptype === 'DP');
            const vpPumps = response.data.filter(pump => pump.pumptype === 'VP');

            setDpOptions(dpPumps);
            setVpOptions(vpPumps);
        } catch (error) {
            console.error('Error fetching DP options:', error);
            //notify('Error fetching DP options');
        }
    };


    useEffect(() => {
        if (loggedInUser) {
            fetchDpVPOptions();
        }
    }, [loggedInUser]);

    useEffect(() => {
        if (dpOptions.length > 0) {
            // Select all options including "Select All"
            const allPumpNames = dpOptions.map(option => option.pumpname);
            setSelectedDPs(allPumpNames);
        }
        if (vpOptions.length > 0) {
            // Select all options including "Select All"
            const allPumpNames = vpOptions.map(option => option.pumpname);
            setSelectedVPs(allPumpNames);
        }
        setSelectedParameters(parameterOptions.map((param) => param.value));
        setSelectedLevels(levelOptions.map((param) => param.value));
        setSelectedLevelsTwo(levelTwoOptions.map((param) => param.value));

    }, [dpOptions]);

    const handleDP = (event) => {
        const { value } = event.target;

        if (value.includes('Select All')) {
            if (selectedDPs.includes('Select All')) {
                // Deselect all
                setSelectedDPs([]);
            } else {
                // Select all pump names
                const allPumpNames = dpOptions.map(option => option.pumpname);
                setSelectedDPs(allPumpNames);
            }
        } else if (selectedDPs.includes('Select All')) {
            // Deselect "Select All" and the item that was clicked
            setSelectedDPs(value.filter(val => val !== 'Select All'));
        } else {
            // Normal selection
            setSelectedDPs(value);
        }
    };

    const handleVP = (event) => {
        const { value } = event.target;

        if (value.includes('Select All')) {
            if (selectedVPs.includes('Select All')) {
                // Deselect all
                setSelectedVPs([]);
            } else {
                // Select all pump names
                const allPumpNames = vpOptions.map(option => option.pumpname);
                setSelectedVPs(allPumpNames);
            }
        } else if (selectedDPs.includes('Select All')) {
            // Deselect "Select All" and the item that was clicked
            setSelectedVPs(value.filter(val => val !== 'Select All'));
        } else {
            // Normal selection
            setSelectedVPs(value);
        }
    };

    const handleParameters = (event) => {
        const value = event.target.value;

        if (value.includes('SelectAll')) {
            // Set all parameters as selected
            setSelectedParameters(parameterOptions.map((param) => param.value));
        } else {
            // Regular selection of individual parameters
            setSelectedParameters(value);
        }
    };

    const handleLevels = (event) => {
        const value = event.target.value;

        if (value.includes('SelectAll')) {
            // Set all parameters as selected
            setSelectedLevels(levelOptions.map((param) => param.value));
        } else {
            // Regular selection of individual parameters
            setSelectedLevels(value);
        }
    };

    const handleLevelsTwo = (event) => {
        const value = event.target.value;

        if (value.includes('SelectAll')) {
            // Set all parameters as selected
            setSelectedLevelsTwo(levelTwoOptions.map((param) => param.value));
        } else {
            // Regular selection of individual parameters
            setSelectedLevelsTwo(value);
        }
    };

    const toggleVisibility = (event) => {
        setIsVisible(event.target.checked);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <div style={{ backgroundColor: '#EBEFF3' }}>
                <Sidebar loggedInUser={loggedInUser} />
                <Header
                    logoUrl={logoUrl}
                    loggedInUser={loggedInUser}
                    onLogout={onLogout}
                    username={username}
                    userRole={userRole}
                />
                <ContentContainer>
                    <MainContent>
                        <Grid container spacing={2} justifyContent="center">
                            <Grid item xs={12} lg={20}>
                                <CenteredCard>
                                    <CardContent>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                            <Box>
                                                <HeaderTitle>VS Analytics</HeaderTitle>
                                                <Typography
                                                    variant="body2"
                                                    component="a"
                                                    onClick={handleDefaultGenerate}
                                                    href="#"
                                                    sx={{
                                                        display: 'block', // Ensure link takes a new line
                                                        mt: 1, // Margin top for spacing below the heading
                                                        color: '#1E90FF', // Link color
                                                        textDecoration: 'none', // Remove underline
                                                        '&:hover': {
                                                            textDecoration: 'underline', // Underline on hover
                                                        },
                                                    }}
                                                >
                                                    Generate Default Report
                                                    <Typography
                                                        component="span"
                                                        sx={{
                                                            color: 'dodgerblue', // Warm orange for contrast
                                                            fontSize: '0.85rem',
                                                            fontWeight: '500', // Semi-bold for a refined look
                                                            ml: 0.5
                                                        }}
                                                    >
                                                        (Last 7 days)
                                                    </Typography>
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                <FormGroup>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={isVisible}
                                                                onChange={toggleVisibility}
                                                                color="primary"
                                                            />
                                                        }
                                                        label={isVisible ? "" : ""}
                                                    />
                                                </FormGroup>
                                                <Box sx={{ ml: 1 }}>
                                                    <RefreshIcon
                                                        title="Refresh"
                                                        src={refreshIcon}
                                                        label="Click to refresh"
                                                        alt="Refresh"
                                                        onClick={() => window.location.reload()}
                                                        sx={{ cursor: 'pointer' }} // Add pointer cursor for better UX
                                                    />
                                                </Box>
                                            </Box>
                                        </Box>
                                        {isVisible && (
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6} md={2.5}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="dp-select-label">Select DP's</InputLabel>
                                                            <Select
                                                                labelId="dp-select-label"
                                                                multiple
                                                                value={selectedDPs}
                                                                onChange={handleDP}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.length > 0 ? (
                                                                            selected.map((value) => (
                                                                                <Chip
                                                                                    key={value}
                                                                                    label={value}
                                                                                    size="small"
                                                                                    style={{ fontSize: '0.75rem', height: '20px' }} // Adjust the font size and height to make it smaller
                                                                                />
                                                                            ))
                                                                        ) : (
                                                                            <em style={{ color: '#808080' }}>Select DP's</em>
                                                                        )}
                                                                    </Box>
                                                                )}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: {
                                                                            maxHeight: 300,
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                <MenuItem key="Select All" value="Select All">
                                                                    Select All
                                                                </MenuItem>
                                                                {dpOptions.map((option) => (
                                                                    <MenuItem key={option.pumpid} value={option.pumpname}>
                                                                        {option.pumpname}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={2.5}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="vp-select-label">Select VP's</InputLabel>
                                                            <Select
                                                                labelId="dp-select-label"
                                                                multiple
                                                                value={selectedVPs}
                                                                onChange={handleVP}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.length > 0 ? (
                                                                            selected.map((value) => (
                                                                                <Chip
                                                                                    key={value}
                                                                                    label={value}
                                                                                    size="small"
                                                                                    style={{ fontSize: '0.75rem', height: '20px' }} // Adjust the font size and height to make it smaller
                                                                                />
                                                                            ))
                                                                        ) : (
                                                                            <em style={{ color: '#808080' }}>Select VP's</em>
                                                                        )}
                                                                    </Box>
                                                                )}
                                                                MenuProps={{
                                                                    PaperProps: {
                                                                        style: {
                                                                            maxHeight: 300,
                                                                        },
                                                                    },
                                                                }}
                                                            >
                                                                <MenuItem key="Select All" value="Select All">
                                                                    Select All
                                                                </MenuItem>
                                                                {vpOptions.map((option) => (
                                                                    <MenuItem key={option.pumpid} value={option.pumpname}>
                                                                        {option.pumpname}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={3}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="parameter-select-label">Select pumps parameter</InputLabel>
                                                            <Select
                                                                labelId="parameter-select-label"
                                                                multiple
                                                                value={selectedParameters}
                                                                onChange={handleParameters}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.map((value) => (
                                                                            <Chip
                                                                                key={value}
                                                                                label={parameterOptions.find(param => param.value === value)?.label || value}
                                                                                size="small"
                                                                                style={{ fontSize: '0.75rem', height: '20px' }} // Adjust the font size and height to make it smaller
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                            >
                                                                <MenuItem value="SelectAll">Select All</MenuItem>
                                                                {parameterOptions.map((option) => (
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>

                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={3}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <InputLabel id="level-select-label">Select general parameters</InputLabel>
                                                            <Select
                                                                labelId="parameter-select-label"
                                                                multiple
                                                                value={selectedLevels}
                                                                onChange={handleLevels}
                                                                renderValue={(selected) => (
                                                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                        {selected.map((value) => (
                                                                            <Chip
                                                                                key={value}
                                                                                label={levelOptions.find(param => param.value === value)?.label || value}
                                                                                size="small"
                                                                                style={{ fontSize: '0.75rem', height: '20px' }}
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                )}
                                                            >
                                                                <MenuItem value="SelectAll">Select All</MenuItem>
                                                                {levelOptions.map((option) => (
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                        {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>

                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                {loggedInUser && loggedInUser.VacuumLevel2CardEnabled && (
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <FormGroup>
                                                            <FormControl variant="standard" sx={{ width: '100%' }}>
                                                                <InputLabel id="level-select-label">Select general parameters (2)</InputLabel>
                                                                <Select
                                                                    labelId="parameter-select-label"
                                                                    multiple
                                                                    value={selectedLevelsTwo}
                                                                    onChange={handleLevelsTwo}
                                                                    renderValue={(selected) => (
                                                                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                                                            {selected.map((value) => (
                                                                                <Chip
                                                                                    key={value}
                                                                                    label={levelTwoOptions.find(param => param.value === value)?.label || value}
                                                                                    size="small"
                                                                                    style={{ fontSize: '0.75rem', height: '20px' }}
                                                                                />
                                                                            ))}
                                                                        </Box>
                                                                    )}
                                                                >
                                                                    <MenuItem value="SelectAll">Select All</MenuItem>
                                                                    {levelTwoOptions.map((option) => (
                                                                        <MenuItem key={option.value} value={option.value}>
                                                                            {option.label}
                                                                        </MenuItem>
                                                                    ))}
                                                                </Select>
                                                            </FormControl>
                                                        </FormGroup>
                                                    </Grid>
                                                )}

                                                <Grid item xs={12} sm={6} md={2.5}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <DatePicker
                                                                label="Select From"
                                                                value={selectedDateFrom}
                                                                onChange={handleDateFrom}
                                                                minDate={thirtyDaysAgo}
                                                                maxDate={today}
                                                                renderInput={(params) => <CustomTextField {...params} />}
                                                                inputFormat="dd/MM/yyyy"
                                                                sx={{
                                                                    width: '100%',
                                                                    '& .MuiInputLabel-root': {
                                                                        fontSize: '0.75rem',
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontSize: '0.8rem',
                                                                    },
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>

                                                <Grid item xs={12} sm={6} md={2.5}>
                                                    <FormGroup>
                                                        <FormControl variant="standard" sx={{ width: '100%' }}>
                                                            <DatePicker
                                                                label="Select To"
                                                                value={selectedDateTo}
                                                                onChange={handleDateTo}
                                                                minDate={selectedDateFrom || thirtyDaysAgo}
                                                                maxDate={today}
                                                                renderInput={(params) => <CustomTextField {...params} />}
                                                                inputFormat="dd/MM/yyyy"
                                                                sx={{
                                                                    width: '100%',
                                                                    '& .MuiInputLabel-root': {
                                                                        fontSize: '0.75rem',
                                                                    },
                                                                    '& .MuiInputBase-root': {
                                                                        fontSize: '0.8rem',
                                                                    },
                                                                }}
                                                            />
                                                        </FormControl>
                                                    </FormGroup>
                                                </Grid>
                                            </Grid>
                                        )}
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: { xs: 'column', sm: 'row' }, // Stack elements vertically on small screens
                                                justifyContent: 'flex-end',
                                                alignItems: 'center',
                                                gap: { xs: 1, sm: 0 }, // Add some gap between stacked elements
                                            }}
                                        >
                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleSearch}
                                                disabled={loading}
                                                sx={{
                                                    marginRight: { xs: 0, sm: '10px' }, // Remove margin on small screens
                                                    borderRadius: '5px',
                                                    padding: '2px 6px',
                                                    fontSize: { xs: '0.65rem', sm: '0.75rem' }, // Smaller font size on mobile
                                                    width: { xs: '100%', sm: 'auto' }, // Full width on mobile
                                                    '&:hover': {
                                                        backgroundColor: '#D9FEE5',
                                                    },
                                                }}
                                            >
                                                {loading ? <CircularProgress size={20} /> : 'Search'}
                                            </Button>

                                            <Button
                                                variant="outlined"
                                                color="primary"
                                                onClick={handleClear}
                                                sx={{
                                                    marginRight: { xs: 0, sm: '50px' }, // Remove margin on small screens
                                                    borderRadius: '5px',
                                                    padding: '2px 6px',
                                                    fontSize: { xs: '0.65rem', sm: '0.75rem' }, // Smaller font size on mobile
                                                    width: { xs: '100%', sm: 'auto' }, // Full width on mobile
                                                    '&:hover': {
                                                        backgroundColor: '#FFCCCB',
                                                    },
                                                }}
                                            >
                                                Clear
                                            </Button>

                                            <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'row', sm: 'row' } }}>
                                                <a href="#" onClick={handleDownloadPDF} style={{ marginRight: '5px' }}>
                                                    <img src={pdfIcon} alt="PDF" style={{ marginRight: '5px', height: '50px' }} /> {/* Adjusted size for mobile */}
                                                </a>

                                                <a href="#" onClick={handleDownloadExcel} style={{ marginRight: '10px' }}>
                                                    <img src={excelIcon} alt="Excel" style={{ marginRight: '5px', height: '50px' }} /> {/* Adjusted size for mobile */}
                                                </a>
                                            </Box>
                                        </Box>
                                    </CardContent>
                                </CenteredCard>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <CardContent>
                                {tableData1.length > 0 ? (
                                    <StyledTableContainer>
                                        <Table>
                                            <StyledTableHead>
                                                <TableRow>
                                                    {renderTableColumns().map((column) => (
                                                        <StyledTableColumn key={column.key}>{column.label}</StyledTableColumn>
                                                    ))}
                                                </TableRow>
                                            </StyledTableHead>
                                            <TableBody>
                                                {tableData1.map((row, index) => (
                                                    <TableRow key={index}>
                                                        {renderTableColumns().map((column) => (
                                                            <StyledTableCell key={column.key}>
                                                                {
                                                                    column.key === 'PUMPNAME' ? (
                                                                        <Link
                                                                            to="#"
                                                                            onClick={() => handlePumpNameClick(row.PUMPNAME)}
                                                                            style={{
                                                                                textDecoration: 'none',
                                                                                color: 'dodgerblue',
                                                                                fontWeight: 'bold',
                                                                                backgroundColor: '#e0f7fa', // Light blue background
                                                                                padding: '4px 8px', // Increased padding for better touch target
                                                                                borderRadius: '8px', // More rounded corners
                                                                                transition: 'background-color 0.3s, color 0.3s', // Smooth transition effects
                                                                            }}
                                                                            onMouseEnter={(e) => {
                                                                                e.target.style.backgroundColor = '#b2ebf2'; // Slightly darker blue on hover
                                                                                e.target.style.color = '#007bb2'; // Darker blue text on hover
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                e.target.style.backgroundColor = '#e0f7fa'; // Revert to original background
                                                                                e.target.style.color = 'dodgerblue'; // Revert to original text color
                                                                            }}
                                                                        >
                                                                            {row.PUMPNAME}
                                                                        </Link>
                                                                    ) : (
                                                                        row[column.key]
                                                                    )
                                                                }
                                                            </StyledTableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </StyledTableContainer>
                                ) : (
                                    <Typography variant="body2" color="textSecondary" component="p">
                                    </Typography>
                                )}
                            </CardContent>
                        </Grid>
                        <Grid item xs={12}>
                            <CardContent>
                                {tableData1DefaultReport.length > 0 ? (
                                    <StyledTableContainer>
                                        <Table>
                                            <StyledTableHead>
                                                <TableRow>
                                                    {renderTableColumnsDefaultreport().map((column) => (
                                                        <StyledTableColumn key={column.key}>{column.label}</StyledTableColumn>
                                                    ))}
                                                </TableRow>
                                            </StyledTableHead>
                                            <TableBody>
                                                {tableData1DefaultReport.map((row, index) => (
                                                    <TableRow key={index}>
                                                        {renderTableColumnsDefaultreport().map((column) => (
                                                            <StyledTableCell key={column.key}>
                                                                {
                                                                    column.key === 'PUMPNAME' ? (
                                                                        row.PUMPNAME
                                                                    ) : (
                                                                        row[column.key]
                                                                    )
                                                                }
                                                            </StyledTableCell>
                                                        ))}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </StyledTableContainer>
                                ) : (
                                    <Typography variant="body2" color="textSecondary" component="p">
                                    </Typography>
                                )}
                            </CardContent>
                        </Grid>

                        <Grid item xs={12}>
                            {selectedLevels.length > 0 && (
                                <CardContent>
                                    {minmaxData && Object.keys(minmaxData).length > 0 ? (
                                        <StyledTableContainer>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        {selectedLevels.includes('VacuumLevel') && <StyledTableColumn>Avg vacuum level (bar)</StyledTableColumn>}
                                                        {selectedLevels.includes('MaxTankLevel') && <StyledTableColumn>Max tank level (m)</StyledTableColumn>}
                                                        {selectedLevels.includes('MinTankLevel') && <StyledTableColumn>Min tank level (m)</StyledTableColumn>}
                                                        {selectedLevels.includes('TotalAlarm') && <StyledTableColumn>Total alarm</StyledTableColumn>}
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        {selectedLevels.includes('VacuumLevel') && <StyledTableCell>{minmaxData.averageVac[0].VACUUM}</StyledTableCell>}
                                                        {selectedLevels.includes('MaxTankLevel') && <StyledTableCell>{minmaxData.maxTank[0].MAXTANK}</StyledTableCell>}
                                                        {selectedLevels.includes('MinTankLevel') && <StyledTableCell>{minmaxData.minTank[0].MINTANK}</StyledTableCell>}
                                                        {selectedLevels.includes('TotalAlarm') && <StyledTableCell>{minmaxData.totalAlarm[0].Alarm}</StyledTableCell>}
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary" component="p">

                                        </Typography>
                                    )}
                                </CardContent>
                            )}
                        </Grid>

                        {loggedInUser && loggedInUser.VacuumLevel2CardEnabled && (
                            <Grid item xs={12}>
                                {selectedLevelsTwo.length > 0 && (
                                    <CardContent>
                                        {minmaxDataTwo && Object.keys(minmaxDataTwo).length > 0 ? (
                                            <StyledTableContainer>
                                                <Table>
                                                    <StyledTableHead>
                                                        <TableRow>
                                                            {selectedLevelsTwo.includes('VacuumLevelTwo') && <StyledTableColumn>Avg vacuum level (2) (bar)</StyledTableColumn>}
                                                            {selectedLevelsTwo.includes('MaxTankLevelTwo') && <StyledTableColumn>Max tank level (2) (m)</StyledTableColumn>}
                                                            {selectedLevelsTwo.includes('MinTankLevelTwo') && <StyledTableColumn>Min tank level (2) (m)</StyledTableColumn>}
                                                        </TableRow>
                                                    </StyledTableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            {selectedLevelsTwo.includes('VacuumLevelTwo') && <StyledTableCell>{minmaxDataTwo.averageVac2[0].VACUUM}</StyledTableCell>}
                                                            {selectedLevelsTwo.includes('MaxTankLevelTwo') && <StyledTableCell>{minmaxDataTwo.maxTank2[0].MAXTANK}</StyledTableCell>}
                                                            {selectedLevelsTwo.includes('MinTankLevelTwo') && <StyledTableCell>{minmaxDataTwo.minTank2[0].MINTANK}</StyledTableCell>}
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </StyledTableContainer>
                                        ) : (
                                            <Typography variant="body2" color="textSecondary" component="p">

                                            </Typography>
                                        )}
                                    </CardContent>
                                )}
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <CardContent>
                                {minmaxDataDefaultReport && Object.keys(minmaxDataDefaultReport).length > 0 ? (
                                    <StyledTableContainer>
                                        <Table>
                                            <StyledTableHead>
                                                <TableRow>
                                                    <StyledTableColumn>Avg vacuum level (bar)</StyledTableColumn>
                                                    <StyledTableColumn>Max tank level (m)</StyledTableColumn>
                                                    <StyledTableColumn>Min tank level (m)</StyledTableColumn>
                                                    <StyledTableColumn>Total alarm</StyledTableColumn>
                                                </TableRow>
                                            </StyledTableHead>
                                            <TableBody>
                                                <TableRow>
                                                    <StyledTableCell>{minmaxDataDefaultReport.averageVac[0].VACUUM}</StyledTableCell>
                                                    <StyledTableCell>{minmaxDataDefaultReport.maxTank[0].MAXTANK}</StyledTableCell>
                                                    <StyledTableCell>{minmaxDataDefaultReport.minTank[0].MINTANK}</StyledTableCell>
                                                    <StyledTableCell>{minmaxDataDefaultReport.totalAlarm[0].Alarm}</StyledTableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </StyledTableContainer>
                                ) : (
                                    <Typography variant="body2" color="textSecondary" component="p">

                                    </Typography>
                                )}
                            </CardContent>
                        </Grid>

                        {loggedInUser && loggedInUser.VacuumLevel2CardEnabled && (
                            <Grid item xs={12}>
                                <CardContent>
                                    {minmaxDataDefaultReportTwo && Object.keys(minmaxDataDefaultReportTwo).length > 0 ? (
                                        <StyledTableContainer>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        <StyledTableColumn>Avg vacuum level (2) (bar)</StyledTableColumn>
                                                        <StyledTableColumn>Max tank level (2) (m)</StyledTableColumn>
                                                        <StyledTableColumn>Min tank level (2) (m)</StyledTableColumn>
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    <TableRow>
                                                        <StyledTableCell>{minmaxDataDefaultReportTwo.averageVac2[0].VACUUM}</StyledTableCell>
                                                        <StyledTableCell>{minmaxDataDefaultReportTwo.maxTank2[0].MAXTANK}</StyledTableCell>
                                                        <StyledTableCell>{minmaxDataDefaultReportTwo.minTank2[0].MINTANK}</StyledTableCell>
                                                    </TableRow>
                                                </TableBody>
                                            </Table>
                                        </StyledTableContainer>
                                    ) : (
                                        <Typography variant="body2" color="textSecondary" component="p">

                                        </Typography>
                                    )}
                                </CardContent>
                            </Grid>
                        )}

                        <Grid item xs={12} lg={20}>
                            <CardContent>
                                {loading ? (
                                    <Grid container justifyContent="center" alignItems="center" style={{ height: '200px' }}>

                                    </Grid>
                                ) : (
                                    Object.keys(totalperdaydata).length > 0 ? (
                                        <StyledTableContainer>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        {(selectedParameters.includes('TotalCyclesPerDay') || selectedLevels.includes('TotalAlarmPerDay')) &&
                                                            <StyledTableColumn>Date</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP1') && <StyledTableColumn>DP1 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP1') && <StyledTableColumn>DP1 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP2') && <StyledTableColumn>DP2 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP2') && <StyledTableColumn>DP2 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP3') && <StyledTableColumn>DP3 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP3') && <StyledTableColumn>DP3 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP4') && <StyledTableColumn>DP4 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedDPs.includes('DP4') && <StyledTableColumn>DP4 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP1') && <StyledTableColumn>VP1 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP1') && <StyledTableColumn>VP1 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP2') && <StyledTableColumn>VP2 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP2') && <StyledTableColumn>VP2 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP3') && <StyledTableColumn>VP3 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP3') && <StyledTableColumn>VP3 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP4') && <StyledTableColumn>VP4 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP4') && <StyledTableColumn>VP4 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP5') && <StyledTableColumn>VP5 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP5') && <StyledTableColumn>VP5 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP6') && <StyledTableColumn>VP6 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP6') && <StyledTableColumn>VP6 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP7') && <StyledTableColumn>VP7 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP7') && <StyledTableColumn>VP7 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP8') && <StyledTableColumn>VP8 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP8') && <StyledTableColumn>VP8 total runs</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP9') && <StyledTableColumn>VP9 total run time</StyledTableColumn>}
                                                        {selectedParameters.includes('TotalCyclesPerDay') && selectedVPs.includes('VP9') && <StyledTableColumn>VP9 total runs</StyledTableColumn>}
                                                        {selectedLevels.includes('TotalAlarmPerDay') && <StyledTableColumn>Total alarm/day</StyledTableColumn>}
                                                    </TableRow>
                                                </StyledTableHead>

                                                <TableBody>
                                                    {(selectedParameters.includes('TotalCyclesPerDay') || selectedLevels.includes('TotalAlarmPerDay')) && (
                                                        totalperdaydata.map((data, index) => (
                                                            <TableRow key={index}>
                                                                {(selectedParameters.includes('TotalCyclesPerDay') || selectedLevels.includes('TotalAlarmPerDay')) &&
                                                                    <StyledTableCell>{data.Date}</StyledTableCell>}
                                                                {selectedDPs.includes('DP1') && selectedParameters.includes('TotalCyclesPerDay') &&
                                                                    <StyledTableCell>{data.dp1totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedDPs.includes('DP1') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.dp1totalcycles || '0'}</StyledTableCell>}
                                                                {selectedDPs.includes('DP2') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.dp2totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedDPs.includes('DP2') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.dp2totalcycles || '0'}</StyledTableCell>}
                                                                {selectedDPs.includes('DP3') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.dp3totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedDPs.includes('DP3') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.dp3totalcycles || '0'}</StyledTableCell>}
                                                                {selectedDPs.includes('DP4') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.dp4totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedDPs.includes('DP4') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.dp4totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP1') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp1totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP1') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp1totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP2') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp2totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP2') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp2totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP3') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp3totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP3') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp3totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP4') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp4totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP4') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp4totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP5') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp5totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP5') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp5totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP6') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp6totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP6') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp6totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP7') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp7totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP7') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp7totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP8') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp8totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP8') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp8totalcycles || '0'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP9') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp9totalduration || '0Sec'}</StyledTableCell>}
                                                                {selectedVPs.includes('VP9') && selectedParameters.includes('TotalCyclesPerDay') && <StyledTableCell>{data.vp9totalcycles || '0'}</StyledTableCell>}
                                                                {selectedLevels.includes('TotalAlarmPerDay') && <StyledTableCell>{data.Alarm || '0'}</StyledTableCell>}
                                                            </TableRow>
                                                        ))
                                                    )}
                                                </TableBody>

                                            </Table>
                                        </StyledTableContainer>

                                    ) : (
                                        <Typography variant="body2" color="textSecondary" align="center">
                                        </Typography>
                                    )
                                )}
                            </CardContent>
                        </Grid>
                        <Grid item xs={12} lg={20}>
                            <CardContent>
                                {loading ? (
                                    <Grid container justifyContent="center" alignItems="center" style={{ height: '200px' }}>

                                    </Grid>
                                ) : (
                                    Object.keys(totalperdaydataDefaultReport).length > 0 ? (
                                        <StyledTableContainer>
                                            <Table>
                                                <StyledTableHead>
                                                    <TableRow>
                                                        <StyledTableColumn>Date</StyledTableColumn>
                                                        {dpOptions.some(dp => dp.pumpname === 'DP1') && <StyledTableColumn>DP1 total run time</StyledTableColumn>}
                                                        {dpOptions.some(dp => dp.pumpname === 'DP1') && <StyledTableColumn>DP1 total runs</StyledTableColumn>}
                                                        {dpOptions.some(dp => dp.pumpname === 'DP2') && <StyledTableColumn>DP2 total run time</StyledTableColumn>}
                                                        {dpOptions.some(dp => dp.pumpname === 'DP2') && <StyledTableColumn>DP2 total runs</StyledTableColumn>}
                                                        {dpOptions.some(dp => dp.pumpname === 'DP3') && <StyledTableColumn>DP3 total run time</StyledTableColumn>}
                                                        {dpOptions.some(dp => dp.pumpname === 'DP3') && <StyledTableColumn>DP3 total runs</StyledTableColumn>}
                                                        {dpOptions.some(dp => dp.pumpname === 'DP4') && <StyledTableColumn>DP4 total run time</StyledTableColumn>}
                                                        {dpOptions.some(dp => dp.pumpname === 'DP4') && <StyledTableColumn>DP4 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP1') && <StyledTableColumn>VP1 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP1') && <StyledTableColumn>VP1 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP2') && <StyledTableColumn>VP2 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP2') && <StyledTableColumn>VP2 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP3') && <StyledTableColumn>VP3 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP3') && <StyledTableColumn>VP3 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP4') && <StyledTableColumn>VP4 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP4') && <StyledTableColumn>VP4 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP5') && <StyledTableColumn>VP5 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP5') && <StyledTableColumn>VP5 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP6') && <StyledTableColumn>VP6 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP6') && <StyledTableColumn>VP6 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP7') && <StyledTableColumn>VP7 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP7') && <StyledTableColumn>VP7 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP8') && <StyledTableColumn>VP8 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP8') && <StyledTableColumn>VP8 total runs</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP9') && <StyledTableColumn>VP9 total run time</StyledTableColumn>}
                                                        {vpOptions.some(vp => vp.pumpname === 'VP9') && <StyledTableColumn>VP9 total runs</StyledTableColumn>}
                                                        <StyledTableColumn>Total alarm/day</StyledTableColumn>
                                                    </TableRow>
                                                </StyledTableHead>
                                                <TableBody>
                                                    {totalperdaydataDefaultReport.map((data, index) => (
                                                        <TableRow key={index}>
                                                            <StyledTableCell>{data.Date}</StyledTableCell>
                                                            {dpOptions.some(dp => dp.pumpname === 'DP1') && <StyledTableCell>{data.dp1totalduration || '0Sec'}</StyledTableCell>}
                                                            {dpOptions.some(dp => dp.pumpname === 'DP1') && <StyledTableCell>{data.dp1totalcycles || '0'}</StyledTableCell>}
                                                            {dpOptions.some(dp => dp.pumpname === 'DP2') && <StyledTableCell>{data.dp2totalduration || '0Sec'}</StyledTableCell>}
                                                            {dpOptions.some(dp => dp.pumpname === 'DP2') && <StyledTableCell>{data.dp2totalcycles || '0'}</StyledTableCell>}
                                                            {dpOptions.some(dp => dp.pumpname === 'DP3') && <StyledTableCell>{data.dp3totalduration || '0Sec'}</StyledTableCell>}
                                                            {dpOptions.some(dp => dp.pumpname === 'DP3') && <StyledTableCell>{data.dp3totalcycles || '0'}</StyledTableCell>}
                                                            {dpOptions.some(dp => dp.pumpname === 'DP4') && <StyledTableCell>{data.dp4totalduration || '0Sec'}</StyledTableCell>}
                                                            {dpOptions.some(dp => dp.pumpname === 'DP4') && <StyledTableCell>{data.dp4totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP1') && <StyledTableCell>{data.vp1totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP1') && <StyledTableCell>{data.vp1totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP2') && <StyledTableCell>{data.vp2totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP2') && <StyledTableCell>{data.vp2totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP3') && <StyledTableCell>{data.vp3totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP3') && <StyledTableCell>{data.vp3totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP4') && <StyledTableCell>{data.vp4totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP4') && <StyledTableCell>{data.vp4totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP5') && <StyledTableCell>{data.vp5totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP5') && <StyledTableCell>{data.vp5totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP6') && <StyledTableCell>{data.vp6totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP6') && <StyledTableCell>{data.vp6totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP7') && <StyledTableCell>{data.vp7totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP7') && <StyledTableCell>{data.vp7totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP8') && <StyledTableCell>{data.vp8totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP8') && <StyledTableCell>{data.vp8totalcycles || '0'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP9') && <StyledTableCell>{data.vp9totalduration || '0Sec'}</StyledTableCell>}
                                                            {vpOptions.some(vp => vp.pumpname === 'VP9') && <StyledTableCell>{data.vp9totalcycles || '0'}</StyledTableCell>}
                                                            <StyledTableCell>{data.Alarm || '0'}</StyledTableCell>
                                                        </TableRow>
                                                    ))
                                                    }
                                                </TableBody>

                                            </Table>
                                        </StyledTableContainer>

                                    ) : (
                                        <Typography variant="body2" color="textSecondary" align="center">
                                        </Typography>
                                    )
                                )}
                            </CardContent>
                        </Grid>
                        <Grid item xs={12} lg={20}>
                            <CardContent ref={detailedData3Ref}>
                                {detailedData.length > 0 ? (
                                    <StyledTableContainer>
                                        <Box display="flex" justifyContent="flex-end" mb={2}>
                                            <Stack spacing={2}>
                                                <Pagination
                                                    count={Math.ceil(detailedData.length / rowsPerPageOne)}
                                                    page={currentPageOne}
                                                    onChange={handlePageChangeOne}
                                                    variant="outlined"
                                                    color="primary"
                                                />
                                            </Stack>
                                        </Box>
                                        <Table>
                                            <StyledTableHead>
                                                <TableRow>
                                                    <StyledTableColumn>Pump name</StyledTableColumn>
                                                    <StyledTableColumn>Start date</StyledTableColumn>
                                                    <StyledTableColumn>Start time</StyledTableColumn>
                                                    <StyledTableColumn>Stop date</StyledTableColumn>
                                                    <StyledTableColumn>Stop time</StyledTableColumn>
                                                    <StyledTableColumn>Run time</StyledTableColumn>
                                                </TableRow>
                                            </StyledTableHead>
                                            <TableBody>
                                                {paginatedDataOne.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <StyledTableCell>{row.pumpname}</StyledTableCell>
                                                        <StyledTableCell>{formatDate(row.starttime)}</StyledTableCell>
                                                        <StyledTableCell>{formatTime(row.starttime)}</StyledTableCell>
                                                        <StyledTableCell>{formatDate(row.time)}</StyledTableCell>
                                                        <StyledTableCell>{formatTime(row.time)}</StyledTableCell>
                                                        <StyledTableCell>{row.DURATION || '0Sec'}</StyledTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </StyledTableContainer>
                                ) : (
                                    <Typography variant="body2" color="textSecondary" component="p">
                                    </Typography>
                                )}
                            </CardContent>
                        </Grid>

                        <Grid item xs={12} lg={20}>
                            <CardContent>
                                {loading ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                                    </Box>
                                ) : (
                                    <>
                                        {detailedDataDP1DP2.length > 0 ? (
                                            <StyledTableContainer>
                                                <Box display="flex" justifyContent="flex-end" mb={2}>
                                                    <Stack spacing={2}>
                                                        <Pagination
                                                            count={Math.ceil(detailedDataDP1DP2.length / rowsPerPageOne)}
                                                            page={currentPageTwo}
                                                            onChange={handlePageChangeTwo}
                                                            variant="outlined"
                                                            color="primary"
                                                        />
                                                    </Stack>
                                                </Box>
                                                <Table>
                                                    <StyledTableHead>
                                                        <TableRow>
                                                            <StyledTableColumn>Pump name</StyledTableColumn>
                                                            <StyledTableColumn>Start date</StyledTableColumn>
                                                            <StyledTableColumn>Start time</StyledTableColumn>
                                                            <StyledTableColumn>Stop date</StyledTableColumn>
                                                            <StyledTableColumn>Stop time</StyledTableColumn>
                                                            <StyledTableColumn>Run time</StyledTableColumn>
                                                        </TableRow>
                                                    </StyledTableHead>
                                                    <TableBody>
                                                        {paginatedDataTwo.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <StyledTableCell>{row.pumpname}</StyledTableCell>
                                                                <StyledTableCell>{formatDate(row.starttime)}</StyledTableCell>
                                                                <StyledTableCell>{formatTime(row.starttime)}</StyledTableCell>
                                                                <StyledTableCell>{formatDate(row.time)}</StyledTableCell>
                                                                <StyledTableCell>{formatTime(row.time)}</StyledTableCell>
                                                                <StyledTableCell>{row.DURATION || '0Sec'}</StyledTableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </StyledTableContainer>
                                        ) : (
                                            <Typography variant="body2" color="textSecondary" component="p">
                                            </Typography>
                                        )}
                                    </>
                                )}
                            </CardContent>
                        </Grid>

                        <Grid item xs={12} lg={20}>
                            <CardContent>
                                {loading ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
                                    </Box>
                                ) : (
                                    <>
                                        {detailedDataVP.length > 0 ? (
                                            <StyledTableContainer>
                                                <Box display="flex" justifyContent="flex-end" mb={2}>
                                                    <Stack spacing={2}>
                                                        <Pagination
                                                            count={Math.ceil(detailedDataVP.length / rowsPerPageOne)}
                                                            page={currentPageThree}
                                                            onChange={handlePageChangeThree}
                                                            variant="outlined"
                                                            color="primary"
                                                        />
                                                    </Stack>
                                                </Box>
                                                <Table>
                                                    <StyledTableHead>
                                                        <TableRow>
                                                            <StyledTableColumn>Pump name</StyledTableColumn>
                                                            <StyledTableColumn>Start date</StyledTableColumn>
                                                            <StyledTableColumn>Start time</StyledTableColumn>
                                                            <StyledTableColumn>Stop date</StyledTableColumn>
                                                            <StyledTableColumn>Stop time</StyledTableColumn>
                                                            <StyledTableColumn>Run time</StyledTableColumn>
                                                        </TableRow>
                                                    </StyledTableHead>
                                                    <TableBody>
                                                        {paginatedDataThree.map((row, index) => (
                                                            <TableRow key={index}>
                                                                <StyledTableCell>{row.pumpname}</StyledTableCell>
                                                                <StyledTableCell>{formatDate(row.starttime)}</StyledTableCell>
                                                                <StyledTableCell>{formatTime(row.starttime)}</StyledTableCell>
                                                                <StyledTableCell>{formatDate(row.time)}</StyledTableCell>
                                                                <StyledTableCell>{formatTime(row.time)}</StyledTableCell>
                                                                <StyledTableCell>{row.DURATION || '0Sec'}</StyledTableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </StyledTableContainer>
                                        ) : (
                                            <Typography variant="body2" color="textSecondary" component="p">
                                            </Typography>
                                        )}
                                    </>
                                )}
                            </CardContent>
                        </Grid>

                    </MainContent>
                </ContentContainer>
                <Footer />
                <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} />
                <ToastContainer />
            </div>
        </LocalizationProvider >
    );
};

export default VSAnalytics;
